import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Row, Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Config from '../../../../../Config';

const CallBackComponent = (props) => {

  const callText = props.isSeparatedSale ? 'הקליקו לשיחה' : 'שיחת חינם' + "  " + Config.numberCallCenterAbroad.replace('+', '').concat('+');
  const phoneImg= <Image height="24px" width="24px" src={require('../images/icon-call/phone.svg')} />;

  return (
    <Container className={`popup-callback-container text-center ${props.isBusiness ? 'isBusiness' : ''}`}>
      <Row className='callBack-description-text'>
        <Col>
            <span>זמינים עבורכם 24/7 בארץ ומהעולם</span>
        </Col>
      </Row>
      {isMobile ? (
        <Row>
          <Col>
            <div className="popup-callback-phone-container-mobile" onClick={() => props.onclick && props.onclick()}>
              <a className="btn popup-callback-call-btn d-block" href={`tel:${Config.numberCallCenterAbroad.replace('-', '')}`}> 
              <span> {phoneImg} &nbsp;{callText} </span>
              </a>
            </div>
          </Col>
        </Row>
       ) : (
        <Row >
          <Col className="popup-callback-phone">
              {phoneImg} &nbsp; {callText}
          </Col>
        </Row>
      )} 
    </Container>
  );
};

export default CallBackComponent;
